import PagesController from "./pages-controller";
export default PagesController
